module.exports = __webpack_public_path__ + "img/camila.3d231d57.svg";